import Typography from '@mui/material/Typography';
import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import UserAvatar from './UserAvatar';
import UserName from './UserName';
import UserLocation from './UserLocation';
import SearchDistance from '../util/SearchDistance';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import { useDispatch, useSelector } from 'react-redux';
import { motion } from 'framer-motion'
import { convertToPlain, truncateText } from 'app/shared-components/utils'
import { createElement } from 'react';
import DisplayUserHtml from "app/shared-components/layout/DisplayUserHtml";


const container = {
    show: {
      transition: {
        staggerChildren: 0.05,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0 },
  };
  



function UserCardItem(props) {
  const { user, onClickBasePath, onClick, searchResult, menu, menuProps, forceId} = props;
  const pathToUser= onClickBasePath ? onClickBasePath + ((user.screenName && !forceId) ? user.screenName : user.id) : undefined;
  const plainAbout= truncateText(convertToPlain(user.about), 300);
  //const plainDescription= truncateText(convertToPlain(user.providerInfo?.description), 300);
  const providerView = Boolean(user.providerInfo);
  const useDistance= searchResult && user.searchResultInfo?.distance;
  const displaySpecializations= !!providerView && user.providerInfo?.specializations && user.providerInfo?.specializations.length > 0;
  const displayAbout= !!user.about;
  const isEmpty= !displayAbout && !displaySpecializations;

  return (

      <Card component={motion.div} style={{height:'100%'}} variants={item} key={user.id} data-testid="user-card" className="mb-10">
          
        
          { onClick &&
             <CardActionArea className="h-full" onClick={() => onClick(user.id)}>
                <GenerateCardBody />
		         </CardActionArea>
          }
          
          { pathToUser &&  !onClick &&
             <CardActionArea className="h-full" component={NavLinkAdapter} to={pathToUser}>
                  <GenerateCardBody />
		         </CardActionArea>
          }
          
		</Card>
    
  );
  
  function GenerateCardBody()
  {
     return (
       <>
       <CardHeader
            className="px-24 pt-24"
            avatar={<UserAvatar user={user} />}
            title={
              <span className="flex items-center space-x-8">
                <UserName user={user} className="font-normal" color="secondary.main"  paragraph={false}/>
              </span>
            }
            subheader={<div> <UserLocation user={user} providerView={providerView}/>
                             {useDistance && <SearchDistance distance={user.searchResultInfo.distance} /> }
                       </div>}
            action={menu ? createElement(menu, {user: user, menuProps: menuProps}) : null}
          />
          
       <CardContent className="px-20 h-full">
         
          
            {user.about && (
                <DisplayUserHtml id={user.id} html={user.about} maxLines="10" />
            )}
            
            
            {!!providerView && user.providerInfo?.specializations && user.providerInfo?.specializations.length > 0 && (
			      <>
			        
			      <Divider style={{width:'100%', margin:'5px'}} />
			  
            <Typography
                display="block"
                variant="body2"
                color="text.secondary"
                sx={{
				  width:'100%',
			      overflow: 'hidden',
			      textOverflow: 'ellipsis',
			      display: '-webkit-box',
			      WebkitLineClamp: '2',
			      WebkitBoxOrient: 'vertical',
			    }}
              >
                 Specializations: {user.providerInfo.specializations.join()}
              </Typography>
              </>
            )}
            
        {isEmpty && 
          <div className="flex flex-row items-center w-full">
            <Typography
                className="inline"
                component="span"
                variant="body2"
                color="text.secondary">No Profile Information Available</Typography>
          </div>
        }

       </CardContent>
       </>
     )
  }
  
}

export default UserCardItem;
